var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ERoute } from "./Routes";
import assign from "lodash/assign";
import values from "lodash/values";
export { useTimeout } from "./useTimeout";
export { usePrevious } from "./userPrevious";
export { getClassName } from "./getClassName";
export { stripFilterPrefix } from "./stripFilterPrefix";
export { redirectToPage, getHashOrPath } from "./redirectToPage";
export { currency } from "./currency";
export { isSupportedBrowser } from "./isSupportedBrowser";
export * from "./scrollToRef";
export * from "./useMediaQuery";
export * from "./getNestedValues";
export * from "./useIntegrationName";
export * from "./CustomTitleRenderer";
export * from "./useToastNotifications";
export var getRoute = function (hashUrl) {
    return values(ERoute).includes(hashUrl.replace(/(\?.+)|#/g, ""));
};
export var normalizeStringToArray = function (csv) {
    if (csv === void 0) { csv = ""; }
    return !csv ? [] : csv.split(",").map(function (v) { return v.trim(); });
};
export var hyphenToCamelCase = function (str) { return str.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); }); };
export var createDomElement = function (_a) {
    var el = _a.el, html = _a.html, nodeAttributes = __rest(_a, ["el", "html"]);
    var tag = document.createElement(el);
    tag.innerHTML = html;
    assign(tag, nodeAttributes);
    return tag;
};
export var addFloatingButtons = function (integrationName) {
    var id = "ws-floating-buttons-" + integrationName;
    if (document.querySelector("#" + id)) {
        return;
    }
    var cartTag = createDomElement({
        id: id,
        el: "div",
        html: "<div class=\"ws-element\" data-integration-name=\"" + integrationName + "\" data-ws-type=\"WSUSERPREVIEWFLOATING\"></div>"
    });
    document.body.appendChild(cartTag);
};
export var addPageScript = function (script, tag) {
    if (tag === void 0) { tag = 'script'; }
    try {
        var id = "websail-" + tag + "s";
        if (document.querySelector("#" + id)) {
            return;
        }
        if (!(script || '').trim())
            return;
        var scriptTag = document.createElement(tag);
        scriptTag.id = id;
        scriptTag.innerHTML = tag === 'script' ? ["try{", script, "} catch (e) { console.log(e) }"].join("") : script;
        document.body.appendChild(scriptTag);
    }
    catch (_a) { }
};
